// initialed state
export const initialState = () => ({
	data: {},
	servicesActionsIds: {},
	servicesSearchOrCreatesActionsIds: {},
	activeAppActionsFetches: {},
	collectionActionsData: {},

	actionsLoadedForCollectionsMap: {},
	actionIdsByVersion: {},
	searchCreateIdsByVersion: {},
	directoryApps: {},
});

const state = initialState();

export default state;
